<template>
	<span :class="labelClass">{{ statoLabel }}</span>
</template>

<script>
export default {
	props: {
		statoLabel: String,
	},

	computed: {
		labelClass() {
			return this.statoLabel ? "sa-stato-color-" + this.statoLabel.replace(" ", "-").replace("/", "-").toLowerCase() : "";
		},
	},
};
</script>

<style>
.sa-stato-color-inserita {
	color: #020202;
}
.sa-stato-color-in-lavorazione {
	color: #0616ff;
}
.sa-stato-color-sospesa {
	color: #ff8b06;
}
.sa-stato-color-completata-o {
	color: #05b10d;
}
.sa-stato-color-rilasciato {
	color: #05b10d;
}
</style>
